import { render, staticRenderFns } from "./mypay.vue?vue&type=template&id=7ddf2f7c&scoped=true&"
import script from "./mypay.vue?vue&type=script&lang=js&"
export * from "./mypay.vue?vue&type=script&lang=js&"
import style0 from "./mypay.vue?vue&type=style&index=0&id=7ddf2f7c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf2f7c",
  null
  
)

export default component.exports